import React, { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

import styles from "./categories-section.module.css";
import { ICategory, getCategorys } from "../../apis/categorys";
import { ROUTES } from "../../routes";
import { SERVICE_FILTERS_KEY } from "../list/list.container";

const iconCache: Record<string, IconDefinition> = {};

const DynamicFaIcon: FC<{ name?: string | null }> = ({ name }) => {
    const [icon, setIcon] = useState<IconDefinition | null>(null);

    useEffect(() => {
        if (!name) return;
        const cacheKey = name.toLowerCase();

        if (iconCache[cacheKey]) {
            setIcon(iconCache[cacheKey]);
            return;
        }

        import("@fortawesome/free-solid-svg-icons")
            .then((mod) => {
                const modKey =
                    "fa" +
                    name
                        .replace(/^fa[-_]?/i, "")
                        .split(/[-_]/)
                        .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
                        .join("");
                const def = (mod as any)[modKey] as IconDefinition | undefined;
                if (def) {
                    iconCache[cacheKey] = def;
                    setIcon(def);
                } else {
                    console.warn(`FontAwesome icon "${name}" not found`);
                }
            })
            .catch((err) => console.error("Error loading icons", err));
    }, [name]);

    return icon ? <FontAwesomeIcon icon={icon as any} /> : null;
};

export const CategoriesSection: FC = () => {
    const [categories, setCategories] = useState<ICategory[]>([]);
    const [expanded, setExpanded] = useState(false);

    const isMobile = useMediaQuery("(max-width:576px)", {
        noSsr: true,
        defaultMatches: false,
    });

    const history = useHistory();

    useEffect(() => {
        getCategorys()
            .then(setCategories)
            .catch((err) => console.error("Error fetching categories", err));
    }, []);

    useEffect(() => {
        sessionStorage.removeItem(SERVICE_FILTERS_KEY);
    }, []);

    const visibleCategories =
        isMobile && !expanded ? categories.slice(0, 8) : categories;

    return (
        <section className={styles.categoriesSection}>
            <div className={styles.container}>
                <div className={styles.grid}>
                    {visibleCategories.map((cat, idx) => (
                        <button
                            key={idx}
                            type="button"
                            className={styles.gridItem}
                            onClick={() =>
                                cat.slug &&
                                history.push({
                                    pathname: ROUTES.SERVICE_LIST_PAGE,
                                    search: `?category=${cat.slug}`,
                                })
                            }
                        >
                            <span className={styles.iconWrapper}>
                                <DynamicFaIcon name={cat.icon} />
                            </span>
                            <span className={styles.label}>{cat.name}</span>
                        </button>
                    ))}
                </div>

                {isMobile && categories.length > 8 && (
                    <div className={styles.toggleButtonWrapper}>
                        <button
                            className={styles.toggleButton}
                            onClick={() => setExpanded((prev) => !prev)}
                        >
                            {expanded ? (
                                <>
                                    Ver menos&nbsp;
                                    <ExpandLess fontSize="medium" />
                                </>
                            ) : (
                                <>
                                    Ver mais&nbsp;
                                    <ExpandMore fontSize="medium" />
                                </>
                            )}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default CategoriesSection;